var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_79_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.65 48.325C55.7875 47.9875 55.9125 47.6625 56.025 47.325C58.7 40.225 60 35.2 60 32C60 24.625 56.95 17.5875 51.4 12.1875C46.05 6.9875 38.9875 4 32 4C25.0125 4 17.95 6.9875 12.6 12.1875C7.05 17.5875 4 24.625 4 32C4 36.1375 6.2125 42.8 8.2 47.9375C8.3 48.2125 8.4125 48.475 8.5125 48.7375C8.55 48.8375 8.6 48.925 8.65 49.0125C8.95 49.6875 9.2875 50.3625 9.675 51.025C12.1875 55.4375 15.9125 58.6625 19.65 59.675C20.4625 59.8875 21.25 60 22.0125 60C23.3375 60 24.575 59.675 25.675 59.0375L27.3875 58.0375L27.4 58.025C29.2625 56.9125 29.9125 54.475 28.8375 52.5875L17.975 33.525C17.45 32.6 16.6 31.9375 15.5875 31.65C14.5625 31.3625 13.5 31.5 12.575 32.025L10.8125 33.05C9.825 33.625 9.025 34.425 8.4 35.375C8.125 34.0375 7.975 32.9 7.975 32C7.975 19.2125 19.1875 8 31.975 8C44.7625 8 55.975 19.2125 55.975 32C55.975 32.75 55.875 33.825 55.55 35.35C54.925 34.4 54.125 33.6125 53.15 33.0375L51.4375 32.0375L51.3875 32.0125C49.4875 30.9375 47.0625 31.6125 45.9875 33.5125L35.125 52.5875C34.05 54.475 34.7 56.9125 36.5625 58.025L38.2875 59.0375C39.3875 59.675 40.625 60 41.95 60C42.7125 60 43.5 59.8875 44.3125 59.675C48.05 58.675 51.775 55.4375 54.2875 51.025C54.6625 50.3625 55 49.6875 55.3125 49.025C55.375 48.925 55.425 48.825 55.4625 48.725C55.5375 48.5875 55.5875 48.45 55.65 48.325ZM10.875 40.95C10.9125 39.6875 11.2125 37.4375 12.8375 36.4875L14.5125 35.5125L25.375 54.5625C25.375 54.575 25.375 54.5875 25.375 54.5875L23.675 55.575C22.875 56.05 21.875 56.125 20.7 55.8125C18.0125 55.0875 15.125 52.5 13.1625 49.05C11.6375 46.3875 10.8125 43.4375 10.875 40.95ZM43.3125 55.8125C42.1375 56.125 41.1375 56.05 40.3375 55.575L38.6375 54.5875C38.625 54.5875 38.625 54.575 38.625 54.5625L49.475 35.5125L51.15 36.4875C52.7875 37.4375 53.0875 39.6875 53.1125 40.95C53.175 43.4375 52.35 46.3875 50.8375 49.05C48.8875 52.5 45.9875 55.0875 43.3125 55.8125Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_79_181",
    x: -0.745136,
    y: -0.248379,
    width: 65.4903,
    height: 66.3199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_79_181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_79_181",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_79_181"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_79_181",
    result: "effect3_innerShadow_79_181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.1c2457f83795c710c9c19fb12d1aa8e7.svg";
export { ForwardRef as ReactComponent };